import React from 'react';
import PropTypes from 'prop-types';

import { GATEWAY_ID_TYPES_PROP } from 'utils/shape-props';
const propTypes = {
  values: PropTypes.shape({
    national_id: PropTypes.string,
    id_type: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    national_id: PropTypes.array,
    id_type: PropTypes.array,
    amount: PropTypes.array,
  }),
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,

  idTypes: GATEWAY_ID_TYPES_PROP.isRequired,
}

const defaultProps = {

}

const SinpeForm = (props) => {
  const idTypes = props.idTypes;

  // Remove hyphens
  const customHandleChange = (event) => {
    const parsedValue = event.target.value && event.target.value.replace("-", "");
    props.setFieldValue("national_id", parsedValue);
  }

  const currentIdType = idTypes.find(( item ) => item.value == props.values.id_type);

  const nationalIdError = props.errors && props.errors.national_id;
  const nationalIdErrorMessage = nationalIdError && nationalIdError.length ? nationalIdError.join(", ") : null;

  return (
    <div>
      <div className="mb16">
        <label className="font-weight-bold" style={{ display: "block", marginBottom: "0.5rem" }}>Tipo de Cédula</label>
        <select onChange={ props.handleChange } name="id_type" className="gateway-dropdown">
          { idTypes.map( (option, index) =>
            <option key={ option.value } value={ option.value }>{ option.label }</option>
          )}
        </select>
      </div>

      <div>
        <label className="font-weight-bold" style={{ display: "block", marginBottom: "0.5rem" }}>Número de Cédula</label>
        <input
          name="national_id"
          className="gateway-text-input"
          value={ props.values.national_id }
          onChange={ customHandleChange }
          placeholder="123456789"
        />
        { nationalIdErrorMessage && <div className="mui-input-error">{ nationalIdErrorMessage }</div> }
      </div>
      <small className="gateway-form-text">
        { currentIdType.instructions || "Debe ser la cédula del titular de la cuenta." }
      </small>
    </div>
  )
};

SinpeForm.propTypes = propTypes;
SinpeForm.defaultProps = defaultProps;

export default SinpeForm;
